import store from '@/store/store'
import Global from '@/mixins/global'
export default {
    name: 'AudioSourcePlayable',
    mixins: [Global],

    methods: {
        play: function (item, stopFunc = null) {
            this._playSound(item, null, stopFunc)
            store.history.putHistory(item)
        },
        playSelected: function (item, stopFunc = null) {
            this._playSound(item, null, stopFunc)
        },
        playHistory: function () {
            const item = store.history.getHistorySelectedItem()
            this._playSound(item)
        },
        playRandom: function () {
            const allSounds = this._getShowingItems()
            const playingItem = allSounds[
                Math.floor(Math.random() * allSounds.length)
            ]
            store.history.putHistory(playingItem)
            this._playSound(playingItem)
        },
        playAll: function () {
            const allSounds = this._getShowingItems()

            this.stopSound()

            const tAudioItems = [].concat(allSounds)
            const endFunc = function () {
                const nextAudioItem = tAudioItems.shift()
                if (nextAudioItem !== undefined) {
                    store.history.putHistory(nextAudioItem)
                    this._playSound(nextAudioItem, endFunc)
                }
            }.bind(this)
            endFunc()
        },
        playRandomAll: function () {
            const allSounds = this._getShowingItems()

            this.stopSound()

            const tAudioItems = [].concat(allSounds)
            const endFunc = function () {
                const nextAudioItem = tAudioItems[
                    Math.floor(Math.random() * tAudioItems.length)
                ]
                store.history.putHistory(nextAudioItem)
                this._playSound(nextAudioItem, endFunc)
            }.bind(this)
            endFunc()
        },
        next: function () {
            store.history.setHistoryIdxToNext()
        },
        prev: function () {
            store.history.setHistoryIdxToPrev()
        },
        consumeAllStopListner() {
            const allStopListner = store.play.getAllStopListner()
            for (const stopListner of Object.values(allStopListner)) {
                stopListner()
            }
            store.play.clearAllListners()
        },
        stopSound: function () {
            for (const audioElement of Object.values(store.play.getAudioElements())) {
                audioElement.pause()
                audioElement.currentTime = 0
            }
            this.consumeAllStopListner()
        },
        _getUniqueStr() {
            var strong = 1000
            return new Date().getTime().toString(16) + Math.floor(strong * Math.random()).toString(16)
        },
        _getShowingItems: function () {
            let allSounds = []
            const pageMode = store.getPageState()
            if (pageMode === 'normal') {
                allSounds = store.getItems()
            } else if (pageMode === 'selection') {
                allSounds = store.getSelectedItems()
            }
            return allSounds
        },
        _playSound: function (audioItem, endFunc = null, stopFunc = null) {
            const url = this.generateDataPath(audioItem.audioPath)
            const audioElement = store.play.loadAudioElement(audioItem, url)

            this._doPlaySound(audioElement, endFunc, stopFunc)
        },
        _doPlaySound: function (audioElement, endFunc = null,stopFunc = null) {
            const playOnReady = function (audioElement, readyFunc = null, endFunc = null, stopFunc = null) {
                if (readyFunc !== null) {
                    audioElement.removeEventListener('canplaythrough', readyFunc)
                }

                audioElement.currentTime = 0
                audioElement.play()

                if (endFunc != null || stopFunc != null) {
                    const funcId = this._getUniqueStr()

                    const onEndedFunc = function onEnded() {
                        audioElement.removeEventListener('ended', onEnded)
                        store.play.removeStopListner(funcId)
                        if( endFunc != null){
                            endFunc()
                        }
                        if( stopFunc != null){
                            stopFunc()
                        }
                    }

                    audioElement.addEventListener('ended', onEndedFunc)
                    store.play.setStopListner(funcId, function () {
                        audioElement.removeEventListener('ended', onEndedFunc)
                        if( stopFunc != null){
                            stopFunc()
                        }
                    })
                }
            }.bind(this)

            if (audioElement.readyState === 4) {
                playOnReady(audioElement, null, endFunc, stopFunc)
            } else {
                audioElement.addEventListener(
                    'canplaythrough',
                    function onSoundLoaded() {
                        playOnReady(audioElement, onSoundLoaded, endFunc, stopFunc)
                    }
                )
            }
        }
    }
}
